// WEEKLY-3 (2026-07-27) — Utilitários do módulo Reuniões Semanais.
// Padrões da casa copiados de src/pages/operacional-contratos/utils.ts e
// src/pages/PlanejamentoCampo.tsx (getToken, unwrap do body, fmt de datas).

import axios from 'axios';
import { fetchAuthSession } from 'aws-amplify/auth';
import dayjs, { Dayjs } from 'dayjs';
import { API_URL } from '../../config';

export async function getToken(): Promise<string> {
  const session = await fetchAuthSession();
  return session.tokens?.idToken?.toString() ?? '';
}

// un() — desembrulha a resposta do API Gateway proxy (padrão da casa):
// r.data.body ? JSON.parse(r.data.body) : r.data
export function un(r: { data: any } | null | undefined): any {
  return r?.data?.body ? JSON.parse(r.data.body) : r?.data;
}

// Chamada padrão do módulo: POST /comercial/propostas-geradas { action, ... }.
// timeoutMs opcional pras ações de IA (gerar briefing / extrair — usar 120000).
export async function api(
  action: string,
  extra: Record<string, any> = {},
  timeoutMs?: number,
): Promise<any> {
  const token = await getToken();
  const r = await axios.post(`${API_URL}/comercial/propostas-geradas`,
    { action, ...extra },
    { headers: { Authorization: token }, ...(timeoutMs ? { timeout: timeoutMs } : {}) });
  return un(r);
}

export function erroMsg(e: any): string {
  return e?.response?.data?.error || e?.message || 'erro desconhecido';
}

// timezone-safe: backend devolve DATE como ISO UTC meia-noite; fatia o
// yyyy-mm-dd antes de formatar senão em BRT (UTC-3) cai no dia anterior.
export function isoDia(v: string | null | undefined): string {
  return v ? String(v).slice(0, 10) : '';
}

export function fmtData(v: string | null | undefined): string {
  const s = isoDia(v);
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
  return m ? `${m[3]}/${m[2]}/${m[1]}` : '—';
}

// Segunda-feira da semana de uma data (0=Dom..6=Sáb)
export function segundaDe(d: Dayjs): Dayjs {
  const dow = d.day();
  return d.subtract((dow + 6) % 7, 'day').startOf('day');
}

// 'DD/MM–DD/MM' (segunda a domingo) a partir do semana_ref
export function fmtSemana(semanaRef: string | null | undefined): string {
  const s = isoDia(semanaRef);
  if (!s) return '—';
  const seg = dayjs(s);
  if (!seg.isValid()) return '—';
  return `${seg.format('DD/MM')}–${seg.add(6, 'day').format('DD/MM')}`;
}

// Postgres numeric/count vira string em node-pg — converter antes de somar/comparar
export const num = (v: number | string | null | undefined): number => {
  if (v == null) return 0;
  const n = typeof v === 'number' ? v : parseFloat(v as any);
  return isNaN(n) ? 0 : n;
};

// Nome do arquivo a partir de uma s3_key (reunioes/{id}/arquivo.vtt → arquivo.vtt)
export function nomeBase(s3Key: string | null | undefined): string {
  if (!s3Key) return '';
  const partes = String(s3Key).split('/');
  return partes[partes.length - 1] || '';
}
